import { tokens } from "@repo/core/theme/tokens";
import { SvgIconProps } from "./types";

const ICON_SIZE_MAP: Record<string, number> = {
  "2xs": 12,
  xs: 15,
  "2sm": 18,
  sm: 24,
  md: 32,
  lg: 48,
  xl: 56,
  "2xl": 72
};

const resolveIconSize = (size: number | string) => {
  if (typeof size === "number") return size;

  return ICON_SIZE_MAP[size] || Number(size) || ICON_SIZE_MAP.md;
};

export const SvgIcon = ({
  size,
  zIndex = 0,
  fill = "$black",
  strokeWidth = 1,
  svg: SvgElement
}: SvgIconProps) => {
  const fillColor =
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (tokens.colors as any)?.[fill.replace(/\$/g, "")] || "#000000";
  const iconSize = resolveIconSize(size);

  return (
    <SvgElement
      style={{ zIndex, pointerEvents: "none" }}
      width={`${iconSize}px`}
      strokeWidth={strokeWidth}
      height={`${iconSize}px`}
      fill={fillColor}
    />
  );
};
